import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import LandingPage from "./pages/LandingPage";
import LearnMorePage from "./pages/LearnMorePage";
import ImpactPage from "./pages/ImpactPage";

function App() {
  const merchantCode = 'ROUND_THEORY';
  const [fetchedImpact, setfetchedImpact] = useState();
  const [projects, setProjects] = useState();

  useEffect(() => {

    if (!location?.pathname.includes('impact')) { // fetch impact projects
      project.projects(null, merchantCode, null)
        .then(response => response.json())
        .then(body => setProjects(body))
        .catch(error => {
          console.error(error);
          setProjects(error);
        })
    }

    impact.merchants(merchantCode, null) // fetch impact
      .then(response => response.json())
      .then(body => {
        setfetchedImpact(body)
      })
      .catch(error => {
        console.error(error);
        setfetchedImpact(error)
      })
  }, []);

  return (
    <>
<meta name="viewport" content="width=device-width, user-scalable=no"></meta>
      <Switch>
      <Route
          exact
          path={`/impact`}
          key="app-MERCHANTNAME-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        <Route
          exact
          path={`/learn-more`}
          key="app-MERCHANTNAME-learnmore"
        >
          <LearnMorePage fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/`}
          key="app-MERCHANTNAME-landing"
        >
          <LandingPage merchantCode={merchantCode} />
        </Route>
      </Switch>

    </>
  );
}

export default App;
